import jwt from 'jsonwebtoken';

import { store } from '../store';

import authConfig from '../config/auth';
import { isValidArray } from '../util/functions';

class AuthService {
  acessToken() {
    const { token } = store.getState().auth;
    try {
      const decoded = jwt.verify(token, authConfig.secret);
      return {
        signed: true,
        exp: decoded.exp,
        colaborador: decoded.colaborador,
        token,
      };
    } catch (error) {
      return {
        signed: false,
        exp: 0,
        token: '',
      };
    }
  }

  getColaborador() {
    const { decodedToken } = store.getState().auth;

    try {
      return decodedToken.colaborador;
    } catch (error) {
      return null;
    }
  }

  getApiInfo() {
    const apiInfo = JSON.parse(localStorage.getItem('apiInfo'));
    return apiInfo;
  }

  checkRoles(arrayNames) {
    const { decodedToken } = store.getState().auth;
    if (!decodedToken) {
      return false;
    }
    const { roles } = decodedToken;

    if (!isValidArray(arrayNames)) {
      arrayNames = arrayNames ? [arrayNames] : [];
    }

    if (arrayNames.length === 0) {
      return true;
    }

    let ret = false;

    arrayNames.forEach(e => {
      if (!roles || !Array.isArray(roles)) {
        return false;
      }
      if (roles.includes(e)) {
        ret = true;
        return true;
      }
    });

    return ret;
  }
}

export default new AuthService();
